let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1WDMs")).then(() => parcelRequire('13xa3'));